meedy.controller('meedy.popupCalendarTermEditController', ['$scope', '$state', '$q', '$timeout', '$mdDialog', '$mdToast', 'objectHelper', 'meedy.resourceModel', 'meedy.availabilityRuleModel', 'meedy.userModel', 'meedy.termModel', 'term', 'termWrapper', 'applicationModel',
    function ($scope, $state, $q, $timeout, $mdDialog, $mdToast, objectHelper, resourceModel, availabilityRuleModel, userModel, termModel, term, termWrapper, applicationModel) {

        function calculatePrivateTermEndDate(date, useDefault) {
            var dateMoment = moment(date).clone();
            if (useDefault) {
                return dateMoment.add(60, 'minutes').clone().toDate();
            }
            else {
                return dateMoment.add(10, 'minutes').clone().toDate();
            }
        }

        function calculateAvailabilityRuleDates(availabilityRuleLocal, appointmentLength) {
            var availableDates = [];
            var GRANULAR = 5;

            var currentDateMoment = moment(availabilityRuleLocal.availabilityRule.startDate);
            var endDateMoment = availabilityRuleLocal.granular ? moment(availabilityRuleLocal.availabilityRule.endDate.getTime() - (appointmentLength * 60 * 1000)) + (60 * 1000 * GRANULAR)
                : moment(availabilityRuleLocal.availabilityRule.endDate.getTime());

            var endOfRuleReached = false;

            while (!endOfRuleReached) {
                var newDateMoment = currentDateMoment.clone().add((availabilityRuleLocal.granular ? 5 : appointmentLength), 'minutes');
                if (newDateMoment.isSameOrBefore(endDateMoment)) {
                    availableDates.push(currentDateMoment.clone().toDate());
                    currentDateMoment = newDateMoment;
                }
                else {
                    endOfRuleReached = true;
                }
            }

            return availableDates;
        }

        function setData() {
            // isolated scope, needs these injected again
            $scope.Enum = Enum;
            $scope.Constant = Constant;

            $scope.privateTerm = (term.type == Enum.MEEDY.TERM_TYPE.PRIVATE_TERM) ? objectHelper.cloneObject(term) : null;
            $scope.privateTermCopy = (term.type == Enum.MEEDY.TERM_TYPE.PRIVATE_TERM) ? objectHelper.cloneObject(term) : null;

            $scope.cyclicTerm = (term.cyclicTerm) ? objectHelper.cloneObject(term.cyclicTerm) : new CyclicTermMeedyVO();

            if (term.cyclicTerm) {
                var momentTime = moment($scope.cyclicTerm.endTime).clone();
                var properEndDate = moment($scope.cyclicTerm.calculatedEndDate).set({'hour': momentTime.hours(), 'minute': momentTime.minutes(), 'second': momentTime.seconds()}).clone().toDate();
                $scope.cyclicTerm.endDate = properEndDate;
            }

            $scope.appointment = (term.type == Enum.MEEDY.TERM_TYPE.INTERNAL || term.type == Enum.MEEDY.TERM_TYPE.PRESCRIPTION) ? objectHelper.cloneObject(term) : null;

            $scope.appointmentDatesBeyondAvailability = {
                date: new Date(),
                hour: new Date()
            };

            $scope.privateTermData = {
                validPrivateTermEndDate: undefined,
                recurrenceButtons: [
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.DATA.NOT_SET', value: null }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.ENUM.RECURRENCE_PATTERN.DAY', value: Enum.MEEDY.RECURRENCE_PATTERN.DAY }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.ENUM.RECURRENCE_PATTERN.WEEK', value: Enum.MEEDY.RECURRENCE_PATTERN.WEEK })
                ]
            };

            if (term.type == Enum.MEEDY.TERM_TYPE.PRIVATE_TERM) {
                $scope.privateTermData.validPrivateTermEndDate = calculatePrivateTermEndDate($scope.privateTerm.begin, false);
            }

            $scope.currentDate = new Date();

            $scope.appointmentData = {
                appointmentLengths: availabilityRuleModel.generateAppointmentTimeOptions(),
                appointmentLength: undefined,
                availableTerms: [],
                availabilityRuleRange: {
                    startDate: $scope.currentDate,
                    days: 4,
                    resourceId: ($scope.appointment) ? $scope.appointment.resource.id : undefined
                },
                availableAppointmentStartDateOptions: [
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.NEAREST', value: $scope.currentDate }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.IN_A_WEEK', value: moment($scope.currentDate).clone().add(7, 'days').toDate() }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.IN_A_MONTH', value: moment($scope.currentDate).clone().add(1, 'months').toDate() }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.IN_3_MONTHS', value: moment($scope.currentDate).clone().add(3, 'months').toDate() }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.BEYOND_AVAILABILITY', value: "BEYOND_AVAILABILITY" })
                ],
                availableAppointmentStartDateOption: $scope.currentDate,
                selectedAvailabilityRuleLocal: null
            };

            if (term.type == Enum.MEEDY.TERM_TYPE.INTERNAL || term.type == Enum.MEEDY.TERM_TYPE.PRESCRIPTION) {
                var appointmentLength = moment($scope.appointment.end).diff(moment($scope.appointment.begin), 'minutes');
                $scope.appointmentData.appointmentLength = _.find($scope.appointmentData.appointmentLengths, function (length) {
                    return (length == appointmentLength);
                });
            }

            $scope.currentMode = null;

            if (term.type == Enum.MEEDY.TERM_TYPE.PRIVATE_TERM) {
                $scope.currentMode = Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM;
            }
            else if (term.type == Enum.MEEDY.TERM_TYPE.INTERNAL) {
                $scope.currentMode = Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT;
            }
            else if (term.type == Enum.MEEDY.TERM_TYPE.PRESCRIPTION) {
                $scope.currentMode = Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT;
            }

            if(termWrapper.appointment) {
                $scope.appointment = termWrapper.appointment;
            }

            $scope.forms = {};
        }

        function setPermissions() {
            $scope.inEdm = userModel.currentUser.inEdm;
        }

        function setListeners() {
            $scope.$watch(function () {
                return applicationModel.actionInProgress;
            }, function (newVal) {
                $scope.actionInProgress = newVal;
            });

            $scope.$watch('cyclicTerm.recurrencePattern', function (newVal, oldVal) {
                if (newVal != oldVal) {
                    if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM) {
                        if (newVal) {
                            $scope.privateTerm.cyclic = true;
                            if($scope.privateTerm.end) {
                                $scope.cyclicTerm.endDate = new Date($scope.privateTerm.end);
                            }
                        }
                        else {
                            $scope.privateTerm.cyclic = false;
                            $scope.cyclicTerm.endDate = null;
                        }
                    }
                }
            });

            $scope.$watch('privateTerm.begin', function (newVal, oldVal) {
                if (newVal && (!oldVal || (oldVal && (newVal.getTime() != oldVal.getTime())))) {
                    $scope.privateTermData.validPrivateTermEndDate = calculatePrivateTermEndDate(newVal, false);
                }
            });

            //$scope.$watch('privateTerm.end', function (newVal, oldVal) {
            //    if ($scope.privateTerm.begin && newVal && (!oldVal || (oldVal && (newVal.getTime() != oldVal.getTime())))) {
            //        var begin = new Date($scope.privateTerm.begin);
            //        var end = new Date(newVal);
            //        if (begin.getDay() != end.getDay() || begin.getMonth() != end.getMonth() || begin.getYear() != end.getYear()) {
            //            var day = new Date($scope.privateTerm.begin).setHours(end.getHours(), end.getMinutes());
            //            $scope.privateTerm.end = new Date(day);
            //        }
            //    }
            //});

            $scope.$watch('privateTerm.allDay', function (newVal, oldVal) {
                if (!_.isUndefined(newVal) && !_.isUndefined(oldVal) && (newVal != oldVal)) {
                    if (newVal) {
                        $scope.privateTerm.begin = moment($scope.privateTerm.begin).clone().set({'hour': 0, 'minute': 0, 'second': 0}).toDate();
                        $scope.privateTerm.end = moment($scope.privateTerm.end).clone().set({'hour': 23, 'minute': 59, 'second': 0}).toDate();
                        $scope.privateTermData.validPrivateTermEndDate = new Date($scope.privateTerm.begin);
                    }
                    else {
                        $scope.privateTerm.begin = $scope.privateTermCopy.begin;
                        $scope.privateTerm.end = calculatePrivateTermEndDate($scope.privateTerm.begin, false);
                        $scope.privateTermData.validPrivateTermEndDate = calculatePrivateTermEndDate($scope.privateTerm.begin, false);
                    }
                }
            });

            $scope.$watch('appointmentData.availableAppointmentStartDateOption', function (newVal, oldVal) {
                if (newVal && (newVal != oldVal) && newVal !== "BEYOND_AVAILABILITY") {
                    $scope.appointmentData.availabilityRuleRange.startDate = newVal;

                    if ($scope.appointmentData.availabilityRuleRange.resourceId) {
                        availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
                            startDate: $scope.appointmentData.availabilityRuleRange.startDate,
                            days: $scope.appointmentData.availabilityRuleRange.days,
                            idResource: $scope.appointmentData.availabilityRuleRange.resourceId
                        }));
                    }
                }
            });

            $scope.$on(Event.MEEDY.AVAILABILITY_RULE.GET_NEAREST_AVAILABILITY_RULE_OCCURENCE.SUCCESS, function (event, data) {
                $scope.appointmentData.selectedAvailabilityRuleLocal = null;

                var upcomingTerms = _.sortBy(data, ['startDate']);

                var upcomingTermsLocal = [];
                _.each(upcomingTerms, function(upcomingTerm) {
                   var availabilityRuleOccurenceLocal = objectHelper.o(CalendarAvailabilityRuleOccurenceLocalVO, {
                       availabilityRule: upcomingTerm,
                       selected: false,
                       granular: false,
                       availableDates: []
                   });

                    upcomingTermsLocal.push(availabilityRuleOccurenceLocal);
                });

                var upcomingTermsByDay = _.groupBy(upcomingTermsLocal, function (availabilityRuleOccurrenceLocal) {
                    return moment(availabilityRuleOccurrenceLocal.availabilityRule.startDate).dayOfYear();
                });

                $scope.appointmentData.availableTerms = upcomingTermsByDay;
            });

            $scope.onAvailabilityRuleGranularChange = function (availabilityRuleLocal) {
                $timeout(function () {
                    availabilityRuleLocal.availableDates = calculateAvailabilityRuleDates(availabilityRuleLocal, $scope.appointmentData.appointmentLength);
                });
            };

            $scope.onAppointmentLengthChanged = function () {
                $scope.appointment.begin = null;
                $scope.appointment.end = null;

                if ($scope.appointmentData.selectedAvailabilityRuleLocal) {
                    $scope.appointmentData.selectedAvailabilityRuleLocal.availableDates = calculateAvailabilityRuleDates($scope.appointmentData.selectedAvailabilityRuleLocal, $scope.appointmentData.appointmentLength);
                }
                else {
                    $scope.resetAvailabilityRuleState();
                }
            };
        }

        function setActions() {
            $scope.showMoreAvailableTerms = function() {
                $scope.appointmentData.availabilityRuleRange.days = $scope.appointmentData.availabilityRuleRange.days + 4;
                availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
                    startDate: $scope.appointmentData.availabilityRuleRange.startDate,
                    days: $scope.appointmentData.availabilityRuleRange.days,
                    idResource: $scope.appointmentData.availabilityRuleRange.resourceId
                }));
            };

            $scope.toggleSelectAvailabilityRule = function(availabilityRuleLocal) {
                var isSelected = availabilityRuleLocal.selected;
                $scope.resetAvailabilityRuleState();
                availabilityRuleLocal.selected = !isSelected;

                if (availabilityRuleLocal.selected) {
                    availabilityRuleLocal.availableDates = calculateAvailabilityRuleDates(availabilityRuleLocal, $scope.appointmentData.appointmentLength);
                    $scope.appointmentData.selectedAvailabilityRuleLocal = availabilityRuleLocal;
                }
            };

            $scope.resetAvailabilityRuleState = function() {
                _.each($scope.appointmentData.availableTerms, function(availableTermDay) {
                    _.each(availableTermDay, function(existingAvailabilityRuleLocal) {
                        existingAvailabilityRuleLocal.selected = false;
                        existingAvailabilityRuleLocal.granular = false;
                        existingAvailabilityRuleLocal.availableDates = [];
                    });
                });

                $scope.appointmentData.selectedAvailabilityRuleLocal = null;
            };

            $scope.selectAvailableDate = function (date) {
                $scope.resetAvailabilityRuleState();

                $scope.appointment.begin = date;
                $scope.appointment.end = moment(date).clone().add($scope.appointmentData.appointmentLength, 'minutes').toDate();
            };

            $scope.selectBeyondAvailableDate = function () {
                var _date = new Date($scope.appointmentDatesBeyondAvailability.date);
                var _hours = new Date($scope.appointmentDatesBeyondAvailability.hour);
                var hours = _hours.getHours();
                var minutes = _hours.getMinutes();
                var modulusVal = minutes % 10;

                // minutes need to be from the beginning in 5 min interval
                if(modulusVal < 5) {
                    minutes = minutes - modulusVal;
                } else if(modulusVal > 5){
                    if(minutes < 50){
                        minutes = minutes - modulusVal + 10;
                    } else {
                        hours++;
                        minutes = 0;
                    }
                }

                $scope.appointment.begin = new Date(_date.getFullYear(), _date.getMonth(), _date.getDate(), hours, minutes, 0);
                $scope.appointment.end = new Date($scope.appointment.begin.getTime() + ($scope.appointmentData.appointmentLength*60*1000));
            };

            $scope.resetAppointmentDate = function () {
                $scope.appointment.begin = null;
                $scope.appointment.end = null;
            };

            $scope.save = function () {
                var successWatcherDisabler = null;
                var errorWatcherDisabler = null;

                if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT) {
                    $scope.forms.appointment.$setSubmitted();

                    if ($scope.forms.appointment.$valid) {

                        termModel.checkConflicts($scope.appointment);

                        var noConflictOccurred = $scope.$on(Event.MEEDY.TERM.CHECK_CONFLICTS.SUCCESS, function (event) {
                            noConflictOccurred();

                            termModel.updateTerm($scope.appointment);

                            successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_TERM.SUCCESS, function (event, result) {
                                successWatcherDisabler();
                                errorWatcherDisabler();

                                var updatedTerm = result;
                                $scope.forms.appointment.$setPristine();

                                $mdDialog.hide(updatedTerm);
                            });

                            errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_TERM.ERROR, function (event, error) {
                                successWatcherDisabler();
                                errorWatcherDisabler();
                            });
                        });

                        var termConflictOccurred = $scope.$on(Event.MEEDY.TERM.CHECK_CONFLICTS.ERROR, function (event, list) {
                            termConflictOccurred();

                            if(list.data && list.data.length > 0) {
                                $mdDialog.show({
                                    templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-conflicts-popup.html',
                                    controller: 'meedy.popupCalendarTermConflictsController',
                                    resolve: {
                                        terms: function () {
                                            return list.data;
                                        },
                                        message: function () {
                                            return 'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.SAVE_TERM_CONFIRMATION_MESSAGE';
                                        },
                                        termWrapper: function () {
                                            return {
                                                appointment: $scope.appointment,
                                                term: term,
                                                action: Constant.MEEDY.DIALOG_EVENT.TERM.EDIT
                                            };
                                        }
                                    }
                                }).then(function (result) {
                                    var createdTerm = result;
                                    $mdDialog.hide(createdTerm);
                                }, function (error) {
                                    //
                                });
                            }
                        });
                    }
                }
                else if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM) {
                    $scope.forms.privateTerm.$setSubmitted();

                    if ($scope.forms.privateTerm.$valid) {
                        if ($scope.privateTerm.cyclic) {
                            $scope.privateTerm.cyclicTerm = $scope.cyclicTerm;
                            $scope.privateTerm.cyclicTerm.endTime = $scope.privateTerm.cyclicTerm.endDate;
                        }
                        else {
                            $scope.privateTerm.cyclicTerm = null;
                        }

                        if ($scope.privateTerm.cyclic && $scope.privateTermCopy.cyclic) {
                            $mdToast.show({
                                controller: 'meedy.toastCalendarCyclicTermModeController',
                                templateUrl: 'meedy/application/view/app/calendar/toast/calendar-cyclic-term-mode-toast.html',
                                parent : $('.calendarTermEditPopup'),
                                hideDelay: false,
                                position: 'bottom right'
                            }).then(
                                function(mode) {

                                    termModel.checkConflicts($scope.privateTerm);

                                    var checkWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CHECK_CONFLICTS.SUCCESS, function (event, result) {
                                        checkWatcherDisabler();

                                        if(mode === Enum.MEEDY.CYCLIC_TERM_UPDATE_TYPE.ALL) {
                                            $scope.privateTerm.cyclicTerm.startDate = $scope.privateTerm.cyclicTerm.startDate;
                                            $scope.privateTerm.cyclicTerm.startTime = $scope.privateTerm.cyclicTerm.startTime;
                                        } else {
                                            $scope.privateTerm.cyclicTerm.startDate = $scope.privateTerm.begin;
                                            $scope.privateTerm.cyclicTerm.startTime = $scope.privateTerm.begin;
                                        }

                                        termModel.updateCyclicTerm(mode, $scope.privateTerm);

                                        var successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_CYCLIC_TERM.SUCCESS, function (event, result) {
                                            successWatcherDisabler();
                                            errorWatcherDisabler();

                                            var updatedTerm = result;
                                            $scope.forms.privateTerm.$setPristine();

                                            $mdDialog.hide(updatedTerm);
                                        });

                                        var errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_CYCLIC_TERM.ERROR, function (event, error) {
                                            successWatcherDisabler();
                                            errorWatcherDisabler();
                                        });
                                    });

                                },
                                function (error) {
                                    // nothing
                                }
                            );
                        }
                        else {

                            if ($scope.privateTerm.cyclic) {
                                $scope.privateTerm.cyclicTerm.startDate = $scope.privateTerm.begin;
                                $scope.privateTerm.cyclicTerm.startTime = $scope.privateTerm.begin;
                            }

                            termModel.checkConflicts($scope.privateTerm);

                            var checkWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CHECK_CONFLICTS.SUCCESS, function (event, result) {
                                checkWatcherDisabler();

                                termModel.updateTerm($scope.privateTerm);

                                successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_TERM.SUCCESS, function (event, result) {
                                    successWatcherDisabler();
                                    errorWatcherDisabler();

                                    var updatedTerm = result;
                                    $scope.forms.privateTerm.$setPristine();

                                    $mdDialog.hide(updatedTerm);
                                });

                                errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_TERM.ERROR, function (event, error) {
                                    successWatcherDisabler();
                                    errorWatcherDisabler();
                                });
                            });
                        }
                    }
                }
            };

            $scope.ok = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {
            if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT) {
                availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
                    startDate: $scope.appointmentData.availabilityRuleRange.startDate,
                    days: $scope.appointmentData.availabilityRuleRange.days,
                    idResource: $scope.appointmentData.availabilityRuleRange.resourceId
                }));
            }
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
